import { render } from "./dyhd.vue?vue&type=template&id=4a612b9f&scoped=true&ts=true"
import script from "./dyhd.vue?vue&type=script&lang=ts"
export * from "./dyhd.vue?vue&type=script&lang=ts"

import "./dyhd.vue?vue&type=style&index=0&id=4a612b9f&lang=less&scoped=true"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a612b9f"]])

export default __exports__